"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let BillingCurrencySelector = class BillingCurrencySelector extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    value;
    onValue(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("value");
    }
    readonly;
    onReadonly(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("readonly");
    }
    internalValue;
    async $$load_internalValue() {
        return this.value;
    }
    options;
    async $$load_options() {
        return this.$app.repo.get('ui_metadata', { path: 'billing_currency_options' });
    }
    ux;
    dataMembers = ['internalValue', 'options', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                internalValue: null,
                options: null,
                ux: null,
            },
        };
    }
    async act_5962862420439144_emit_6882_getActionArgs($event) {
        return {
            event: "input",
            value: this.internalValue,
        };
    }
    async evh_5962862420439144_input(event, scope) {
        return await this.actions.evh_5962862420439144_input.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_5962862420439144_emit_6882 = new core_1.actions.EmitAction({
            actionArgs: this.act_5962862420439144_emit_6882_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_input_6881 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_emit_6882,
            event: "input",
            displayName: "emit",
        });
        const evh_5962862420439144_input = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_input_6881],
        });
        return {
            act_5962862420439144_emit_6882,
            evh_5962862420439144_input_6881,
            evh_5962862420439144_input,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], BillingCurrencySelector.prototype, "value", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('value'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BillingCurrencySelector.prototype, "onValue", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], BillingCurrencySelector.prototype, "readonly", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('readonly'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BillingCurrencySelector.prototype, "onReadonly", null);
BillingCurrencySelector = __decorate([
    (0, vue_property_decorator_1.Component)()
], BillingCurrencySelector);
exports.default = BillingCurrencySelector;
vue_property_decorator_1.Vue.component("BillingCurrencySelector", BillingCurrencySelector);
